/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjcxIDRMNy43MSAxMEwxLjcxIDRMMSA0LjcxTDcuNzEgMTEuNDJMMTQuNDIgNC43MUwxMy43MSA0WiIgZmlsbD0iaW5oZXJpdCIvPjwvc3ZnPg==";